import React from 'react'
import { useNavigate } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import { ProfileForm, DeleteUserWidget } from '../components'
import authentication from '../http/auth'


function ProfilePage() {
  const navigate = useNavigate()

  const deleteUser = () => {
    let username = localStorage.getItem('username')
    authentication.delete(username, (result) => {
      if (result) {
        navigate('/login')
      } else {
        navigate('/')
      }
    })
  }

  const updateUser = (password, confirm, id, key, cb) => {
    let username = localStorage.getItem('username')
    authentication.update(username, password, confirm, id, key, cb)
  }

  return (
    <DocumentTitle title={'Café App'}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h3>Editer votre profil</h3>
            <hr />
          </div>
        </div>
        <ProfileForm updateUser={updateUser} />
        <div className="row">
          <div className="col-xs-12">
            <h3>Supprimer votre profil</h3>
            <hr />
          </div>
        </div>
        <DeleteUserWidget deleteUser={deleteUser} />
      </div>
    </DocumentTitle>
  )
}

export default ProfilePage
